const n = "0123456789abcdef";
function o(r) {
  let e = "";
  for (let t = 0; t < r; t++) {
    let a = Math.floor(Math.random() * Math.floor(n.length));
    e += n[a];
  }
  return e;
}
function g() {
  return `h_${o(10)}`;
}
export {
  g as generateHeadingId
};
